import { Dispatch, bindActionCreators } from "redux"
import { connect } from "react-redux"
import sessionActionCreators from "../../../actions/sessionActionCreator"

const mapDispatchToProps = (dispatch: Dispatch) => ({
  sessionActions: bindActionCreators(sessionActionCreators, dispatch),
})

export const container = connect(null, mapDispatchToProps)
